import React from 'react';
import { AsyncSelect, AsyncSelectImplementationProps, GetOptions } from './async-select';
import { useApiClient } from '~/api-client';
import { OTHER_OPTION } from '../option';
import { VehiclescodesResource } from '@mark43/rms-api';

type VehicleMakeSelectProps = Omit<AsyncSelectImplementationProps, 'minimumQueryLength'>;

export const VehicleMakeSelect = React.forwardRef<HTMLDivElement, VehicleMakeSelectProps>(
    function VehicleMakeSelect(props: VehicleMakeSelectProps, ref): React.ReactElement {
        const apiClient = useApiClient();
        const getOptions: GetOptions = React.useCallback(
            (query: string) => {
                return apiClient
                    .request<VehiclescodesResource.GetVehicleMakes>({
                        method: 'GET',
                        url: 'vehicles/codes/makes/',
                        params: {
                            q: query,
                            from: 0,
                            size: 50,
                        },
                        service: 'RMS',
                    })
                    .then((response) => {
                        const data = response.data.data;
                        if (data) {
                            const options = data.map((datum) => ({
                                value: datum.id,
                                label: datum.makeName,
                            }));
                            return options;
                        } else {
                            return [];
                        }
                    })
                    .then((options) => {
                        // Always append the `other_option`
                        return options.concat(OTHER_OPTION);
                    });
            },
            [apiClient]
        );
        return (
            <AsyncSelect
                {...props}
                ref={ref}
                getOptions={getOptions}
                minimumQueryLength={2}
                debounceTimer={500}
            />
        );
    }
);
